/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/12/calendar': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M11 2h-1V0H8v2H4V0H2v2H1a1 1 0 00-1 1v8a1 1 0 001 1h10a1 1 0 001-1V3a1 1 0 00-1-1zm-1 8H2V5h8z" _fill="#272c33"/>'
  }
})
